import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import ImageComponent from "../image";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './../../../util'

function ImageCarousel({ data, style, color, index, contentBlockId }) {
  const isSharped = color?.elements.shape === "Sharp";
  const [aspectRatio, setAspectRatio] = useState("");
  const { pageId, userId } = useAppContext()

  useEffect(() => {
    const loadImageData = async () => {
      let localLargestWidth = 0;
      let localLargestHeight = 0;
      let localLargestImageSrc = "";

      for (const src of data) {
        const img = new Image();
        img.src = src;
        await img.decode();

        if (
          img.naturalWidth > localLargestWidth &&
          img.naturalHeight > localLargestHeight
        ) {
          localLargestWidth = img.naturalWidth;
          localLargestHeight = img.naturalHeight;
          localLargestImageSrc = src;
        }
      }

      if (localLargestWidth > 0 && localLargestHeight > 0) {
        const ratio = localLargestWidth / localLargestHeight;
        setAspectRatio(ratio);
      }
    };

    if (data.length > 0) {
      loadImageData();
    }
  }, [data]);

  const handleClicked = () => {
    logContentBlockPressEvent(contentBlockId);
  };

  const handleChange = (index) => {
    if (index === data.length - 1) {
      mixpanel.track(
        "Web Carousel Scrolled", 
        { 
          stack_id: pageId, 
          distinct_id: userId,
        }
      )
    }
  };
  return (
    <div
      key={index}
      style={{
        marginTop: "8px",
      }}
      onClick={handleClicked}
    >
      <Carousel
        showArrows={false}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        interval={3000}
        onChange={handleChange}
        className={isSharped ? "" : "carousels"}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
            return (
              <li
                style={{
                  background: "white",
                  width: "10px",
                  height: "10px",
                  borderRadius: "1rem",
                  display: "inline-block",
                  margin: "0 4px",
                  opacity: 1,
                  boxShadow: "0px 1px 2px 0px #00000040",
                }}
                aria-label={`Selected: ${label} ${index + 1}`}
              />
            );
          }
          return (
            <li
              style={{
                background: "white",
                opacity: 0.4,
                width: "10px",
                height: "10px",
                borderRadius: "1rem",
                display: "inline-block",
                margin: "0 4px",
                cursor: "pointer",
                boxShadow: "0px 1px 2px 0px #00000040",
              }}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              value={index}
              key={index}
              role="button"
              tabIndex={0}
              aria-label={`${label} ${index + 1}`}
            />
          );
        }}
      >
        {data.map((item, index) => {
          return (
            <div key={index}>
              <ImageComponent
                src={item}
                alt="Page carousel"
                style={style}
                color={color}
                isCarousel={true}
                aspectRatio={aspectRatio}
              />
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}

export default React.memo(ImageCarousel);
